import { getCurrentCommitHash } from 'utils/environment';

export const platform = 'web';
export const host = window.location.host;
export const appVersion = getCurrentCommitHash();
export const userClient = window.navigator.userAgent;
export const appShellVersion = ''; // no app shell on web
